import { useEffect, useState } from "react";
import { Button, Col, Form, Row, Spinner } from "react-bootstrap";
import BlockContainer from "../components/BlockContainer";
import { ICON_STEP } from "../components/icons";
import { AddMaolamUser, QueryOwnMaolam } from "../databases/maolam";
import { MAOLAM_APPROVED, MAOLAM_NONE, MAOLAM_REJECTED, MAOLAM_WAITING } from "../databases/spName";


const initialAccept = {
    data : false,
    rule : false,
    document : false,
    pdpa : false,
}

const MaolamStatusString = {
    "" : '',
    [MAOLAM_NONE] : 'ยังไม่ลงทะเบียน เที่ยวบินเหมาลำ',
    [MAOLAM_WAITING] : 'รอการยอมรับ',
    [MAOLAM_REJECTED] : 'การลงทะเบียนถูกปฏิเสธ!',
    [MAOLAM_APPROVED] : 'ลงทะเบียนสำเร็จ'
}

const [BINAENG_START, BINAENG_TICKET, BINAENG_VISA, BINAENG_COVID, BINAENG_JKM, BINAENG_END] = [0, 1, 2, 3, 4, 5]
const BinAengStatusString = {
    [BINAENG_START] : 'เตรียมตัวก่อนเดินทาง',
    [BINAENG_TICKET] : 'ซื้อตั๋วเครื่องบิน',
    [BINAENG_VISA] : 'ทำวีซ่าและรับวีซ่า',
    [BINAENG_COVID] : 'ตรวจโควิด',
    [BINAENG_JKM] : 'ขอรหัสสุขภาพ',
    [BINAENG_END] : 'เดินทางสู่แดนมังกร',
}

const PageMaolamRegister = () => {

    const [isAccept, setAccept] = useState({...initialAccept})
    const [mao, setMao] = useState({ status : null }) 
    const [binAeng, setBinAeng] = useState(BINAENG_START)
    const [onLoading, setOnLoading] = useState(false)

    useEffect(() => {
        return () => {
            setAccept({...initialAccept})
            setOnLoading(false)
            setBinAeng(BINAENG_START)
        }
    }, [])

    useEffect(() => {
        const q = async () => {
            const m = await QueryOwnMaolam()
            setMao(m)
        }
        q()
        return () => {
            setMao({ status : null }) 
        }
    }, [])

    const onAcceptChange = e => setAccept(a => ({...a, [e.target.name] : e.target.checked }))

    const onRegisterClick = async () => {
        try {
            setOnLoading(true)
            await AddMaolamUser()
            alert('ลงทะเบียนสำเร็จ')
            const m = await QueryOwnMaolam()
            setMao(m)
        }
        catch (e) {
            console.log(e)
        }
        finally {
            setOnLoading(false)
        }
    }

    return (
        <div>
            <div hidden={false}>
            **เฉพาะผู้ที่ยังไม่เคยลงทะเบียนในเที่ยวบินเหมาลำเท่านั้น** 
            <BlockContainer>
                <Row>
                    <Col className='col bold'>
                        สถานะ : 
                        {mao.status === 2 ? 
                            <div className="text-danger"><br />เหตุผล :</div> 
                        : ''}
                    </Col>
                    <Col>
                        {MaolamStatusString[mao.status || ""]}
                        {mao.status === 2 ? 
                            <div className="text-danger"><br />{mao.reason || ''}</div> 
                        : ''}
                    </Col>
                </Row>

            </BlockContainer>
            <br />
            <BlockContainer>
                <div className="bold">คำแนะนำ</div>
                <div>1. โปรดกรอกข้อมูล _____(รอผู้ประกาศเสียงทองคิดคำ)_____ ให้เรียบร้อยก่อน</div>
                <div>2. โปรดรวมหลักฐาน JW, 录取通知书，返校证明 _____(รอผู้ประกาศเสียงทองคิดคำ)_____ เป็นไฟล์ pdf ไฟล์เดียว จากนั้นอัปโหลดไฟล์ในช่อง "เอกสารอื่น ๆ"</div>
                <div>3. .....</div>
            </BlockContainer>
            <br />
            <BlockContainer>
                <div className="bold">กติกา กฎสมาคม ตัวอย่างที่ไม่ควร ใด ๆ</div>
                <div>_____(รอผู้ประกาศเสียงทองคิดคำ)_____</div>
            </BlockContainer>
            <br />
            <BlockContainer>
                <div className="bold">ฉันยอมรับ</div>
                <Form.Check 
                    checked={isAccept.data} label=" 1. ข้าพเจ้าได้กรอกข้อมูลในระบบ และตรวจสอบข้อมูล 1 2 3 4 แล้ว หากข้อมูลมีการเปลี่ยนแปลง ข้าพเจ้าจะแก้ไขภายในวันที่สมาคมกำหนด" name={`data`} id={`form-maolam-1`}
                    onChange={onAcceptChange} 
                />
                <Form.Check 
                    checked={isAccept.rule} label=" 2. ข้าพเจ้ายอมรับกฎสมาคม . . . จะไม่เบี้ยว คุยกับป๊าแล้ว (รอผู้ประกาศเสียงทองคิดคำ)" name={`rule`} id={`form-maolam-2`}
                    onChange={onAcceptChange} 
                />
                <Form.Check 
                    checked={isAccept.document} label=" 3. ข้าพเจ้ายืนยันว่าเอกสารที่มี จะทำวีซ่าได้ ไม่ขาดตกใด ๆ และได้อัปโหลดในช่องเอกสารอื่น ๆ แล้ว (รอผู้ประกาศเสียงทองคิดคำ) กรณีไม่ครบให้คุยกับคุณป่านเองค่ะ!" name={`document`} id={`form-maolam-3`}
                    onChange={onAcceptChange} 
                />
                <Form.Check 
                    checked={isAccept.pdpa} label={<div> 4. ข้าพเจ้ายอมรับ<a href='./pdf/นโยบายการคุ้มครองข้อมูลส่วนบุคคล.pdf'>นโยบายการคุ้มครองข้อมูลส่วนบุคคล</a> (Privacy Policy)</div>} name={`pdpa`} id={`form-maolam-4`}
                    onChange={onAcceptChange} 
                />
                <br />
                <div className="text-end">
                    <Button onClick={onRegisterClick} disabled={!isAccept.data || !isAccept.rule || !isAccept.document || !isAccept.pdpa || onLoading}>{<Spinner hidden={!onLoading} size='sm' animation="border" />} ลงทะเบียนเที่ยวบินเหมาลำ</Button>
                </div>
            </BlockContainer>
            </div>
            <div hidden={true}>
                คำแนะนำสำหรับบินเอง
                <br />
                <BlockContainer>
                    <div style={{zIndex: '1', position : 'relative', marginLeft : '-16px'}}>
                        
                    <Row bsPrefix="row align-items-center text-center">
                        {[Object.keys(ICON_STEP).map((iconkey, index) => (
                            <Col xs={2} key={index}>
                                <Button
                                    variant={binAeng < iconkey ? 'round-light' : binAeng > iconkey ? 'round-success' : 'round-warning'}
                                    onClick={() => setBinAeng(parseInt(iconkey))}
                                >{ICON_STEP[iconkey]}</Button>
                            </Col>
                        ))]}
                    </Row>
                    </div>
                    <span style={{display:'block', width:'8.33%', float:'left', height:'5px', marginLeft : '-16px'}}>
                        <hr style={{color : '#faad14', marginTop : '-24px', zIndex : '0', borderWidth : '5px', position : 'relative'}}/>
                    </span>
                    <span style={{display:'block', width:'16.66%', float:'left', height:'5px', marginLeft : '-16px'}}>
                        <hr style={{ marginTop : '-24px', zIndex : '0', borderWidth : '5px', position : 'relative'}}/>
                    </span>
                
                    <span style={{display:'block', width:'16.66%', float:'left', height:'5px'}}><hr style={{color : 'black', marginTop : '-24px', zIndex : '0', borderWidth : '5px', position : 'relative'}}/></span>
                </BlockContainer>
                <br />
                <BlockContainer>
                    <h5>{BinAengStatusString[binAeng]}</h5>
                    <RenderBinaeng binAeng={binAeng} />
                </BlockContainer>
            </div>

        </div>

    )
}

const RenderBinaeng = props => {
    const { binAeng } = props
    switch (binAeng) {
        case BINAENG_START: default:
            return (
                <div>
                    <div className='bold'>1. เตรียมเอกสาร เตรียมเงินให้พร้อม</div>
                    <div></div>
                    <div className='bold'>2. ศึกษาเส้นทางการบิน</div>
                    <div>แนะนำหาเส้นทางการบินที่บินตรง เพื่อความสะดวกในการขอโค้ด</div>
                    <div className='bold'>3. แจ้งมหาวิทยาลัยให้ทราบ</div>
                    <div></div>
                </div>
            )
        case BINAENG_TICKET:
            return (
                <div>
                    <div className='bold'>1. เตรียมเอกสาร เตรียมเงินให้พร้อม</div>
                    <div></div>
                </div>
            )
        case BINAENG_VISA:
            return (
                <div>
                    3
                </div>
            )
        case BINAENG_COVID:
            return (
                <div>
                    
                </div>
            )
        case BINAENG_JKM:
            return (
                <div>
                    
                </div>
            )
        case BINAENG_END:
            return (
                <div>
                    
                </div>
            )
    }
}

export default PageMaolamRegister;


/**
 * เตรียมตัว
 * ซื้อตั๋ว
 * ทำวีซ่า
 * ตรวจโควิด
 * ขอโค้ดเขียว
 */